<template lang='pug'>
div
  slot(
    :dateNext='dateNext'
    :datePrevious='datePrevious'
    :dateShort='dateShort'
    :dateToday='dateToday'
    :isNotToday='isNotToday'
    :locationNext='locationNext'
    :locationNextMonth='locationNextMonth'
    :locationPrevious='locationPrevious'
    :locationPreviousMonth='locationPreviousMonth'
    :locationToday='locationToday'
    :monthNext='monthNext'
    :monthPrevious='monthPrevious'
  )
</template>

<script>
import { routeParamToShortDate } from '../functions/routeParamToShortDate';

import moment from 'moment';

const mounted = function ()
{
  const handler = () =>
  {
    this.dateToday = moment().format('YYYY-MM-DD');

    this.timeoutID = window.setTimeout(handler, 1000 * 60);
  };

  handler();
};

const destroyed = function ()
{
  window.clearTimeout(this.timeoutID);
};

const isNotToday = function ()
{
  return this?.dateToday !== this?.date;
};

const dateNext = function ()
{
  return moment(this?.date)
  .add(1, 'd')
  .format('YYYY-MM-DD');
};

const datePrevious = function ()
{
  return moment(this?.date)
  .subtract(1, 'd')
  .format('YYYY-MM-DD');
};

const dateShort = function ()
{
  return routeParamToShortDate(this?.date);
};

const locationNext = function ()
{
  return { params: { date: this?.dateNext } };
};

const locationNextMonth = function ()
{
  return { params: { date: this?.monthNext } };
};

const locationPrevious = function ()
{
  return { params: { date: this?.datePrevious } };
};

const locationPreviousMonth = function ()
{
  return { params: { date: this?.monthPrevious } };
};

const locationToday = function ()
{
  return { params: { date: this?.dateToday } };
};

const monthNext = function ()
{
  return moment(this?.date)
  .startOf('month')
  .add(1, 'months')
  .format('YYYY-MM-DD');
};

const monthPrevious = function ()
{
  return moment(this?.date)
  .startOf('month')
  .subtract(1, 'months')
  .format('YYYY-MM-DD');
};

export default
{
  computed:
  {
    dateNext,
    datePrevious,
    dateShort,
    isNotToday,
    locationNext,
    locationNextMonth,
    locationPrevious,
    locationPreviousMonth,
    locationToday,
    monthNext,
    monthPrevious,
  },
  data()
  {
    return {
      timeoutID: null,
      dateToday: moment().format('YYYY-MM-DD'),
    };
  },
  destroyed,
  mounted,
  props:
  {
    date: { required: true },
  },
};
</script>